import { GET_CAN_VIEW_PEERS, GET_MAX_TARGET_SCORE } from "../actions.type";
import {
  GET_CAN_VIEW_PEERS_FULFILLED,
  GET_CAN_VIEW_PEERS_PENDING,
  GET_CAN_VIEW_PEERS_REJECT,
  GET_MAX_TARGET_SCORE_FULFILLED,
  GET_MAX_TARGET_SCORE_PENDING,
  GET_MAX_TARGET_SCORE_REJECTED,
  SET_MAX_TARGET_SCORE,
  SET_CAN_VIEW_PEERS,
} from "../mutations.type";
import { GET_MAX_TARGET_VALUE_API } from "@/api/targetSettingsApi";
import { GET_SETTING_CAN_VIEW_PEERS_API } from "@/api/settingsApi";
import {
  DEFAULT_CAN_VIEW_PEERS,
  DEFAULT_MAX_TARGET_VALUE,
} from "@/common/constant";

export const state = {
  maxTargetScore: {
    data: {
      maxScore: DEFAULT_MAX_TARGET_VALUE,
      description: "",
    },
    loading: false,
    error: false,
  },
  canViewPeers: {
    data: {
      value: DEFAULT_CAN_VIEW_PEERS,
      description: "",
    },
    loading: false,
    error: false,
  },
};

const getters = {
  maxTargetScore: (state) => state.maxTargetScore,
};

const mutations = {
  // Get Target Score
  [GET_MAX_TARGET_SCORE_PENDING](state) {
    state.maxTargetScore.loading = true;
  },
  [GET_MAX_TARGET_SCORE_FULFILLED](state, payload) {
    state.maxTargetScore.loading = false;
    state.maxTargetScore.data = payload;
  },
  [GET_MAX_TARGET_SCORE_REJECTED](state) {
    state.maxTargetScore.loading = false;
    state.maxTargetScore.error = true;
  },
  [SET_MAX_TARGET_SCORE](state, payload) {
    vm.$set(state.maxTargetScore, "data", payload);
  },

  // get can view peers setting
  [GET_CAN_VIEW_PEERS_PENDING](state) {
    state.canViewPeers.loading = true;
  },
  [GET_CAN_VIEW_PEERS_FULFILLED](state, payload) {
    state.canViewPeers.loading = false;
    state.canViewPeers.data = payload;
  },
  [GET_CAN_VIEW_PEERS_REJECT](state) {
    state.canViewPeers.loading = false;
    state.canViewPeers.error = true;
  },
  [SET_CAN_VIEW_PEERS](state, payload) {
    vm.$set(state.canViewPeers, "data", payload);
  },
};

const actions = {
  async [GET_MAX_TARGET_SCORE]({ commit }) {
    commit(GET_MAX_TARGET_SCORE_PENDING);
    try {
      const { data } = await GET_MAX_TARGET_VALUE_API();
      commit(GET_MAX_TARGET_SCORE_FULFILLED, data);
    } catch (e) {
      commit(GET_MAX_TARGET_SCORE_REJECTED);
    }
  },

  async [GET_CAN_VIEW_PEERS]({ commit }) {
    commit(GET_CAN_VIEW_PEERS_PENDING);
    try {
      const { data } = await GET_SETTING_CAN_VIEW_PEERS_API();
      commit(GET_CAN_VIEW_PEERS_FULFILLED, data);
      commit(GET_CAN_VIEW_PEERS_REJECT);
    } catch (e) {
      commit(GET_CAN_VIEW_PEERS_REJECT);
    }
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
